// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase, func-names, default-param-last */
import { createSelector } from "reselect"
import type { OutputSelector } from "reselect"
import { uniqBy } from "ramda"
import type { Dispatch } from "redux"
import { bidSelector, bookingDataSelector } from "@kiwicom/frontend-common/services/booking/booking"

import type { BookingId } from "../../../../../types/primitiveTypes"
import { transport } from "../../../../../services/api/transport"
import mapperBookingLocked from "../../Booking/services/mapper/services/mapperBookingLocked"
import { currentBookingJourneySelector } from "../../Booking/services/selector"
import type {
  BookingLocked,
  BookingLockedCredentials,
  BookingLockedCredentialsWithFlight,
} from "./types"
import mmbTrack from "../../../../../services/tracking/mmbTrack"
import {
  BookingLockedModule,
  UnexpectedServerResponseAction,
} from "../../../../../services/tracking/constants/trackingEvents"

export const GET_BOOKING_LOCKED_CREDENTIALS = "GET_BOOKING_LOCKED_CREDENTIALS"
export const GET_BOOKING_LOCKED_CREDENTIALS_REQUEST = "GET_BOOKING_LOCKED_CREDENTIALS_REQUEST"
export const GET_BOOKING_LOCKED_CREDENTIALS_SUCCESS = "GET_BOOKING_LOCKED_CREDENTIALS_SUCCESS"
export const GET_BOOKING_LOCKED_CREDENTIALS_FAILURE = "GET_BOOKING_LOCKED_CREDENTIALS_FAILURE"

export const POST_BOOKING_LOCKED_AUTO_REFUND = "POST_BOOKING_LOCKED_AUTO_REFUND"
export const POST_BOOKING_LOCKED_AUTO_REFUND_REQUEST = "POST_BOOKING_LOCKED_AUTO_REFUND_REQUEST"
export const POST_BOOKING_LOCKED_AUTO_REFUND_SUCCESS = "POST_BOOKING_LOCKED_AUTO_REFUND_SUCCESS"
export const POST_BOOKING_LOCKED_AUTO_REFUND_FAILURE = "POST_BOOKING_LOCKED_AUTO_REFUND_FAILURE"

const fetchBookingLockedCredentials = (bid: BookingId) =>
  transport("GET", bid, `/mmb/v1/bookings/${bid}/handover/credentials`, null, null).then(
    mapperBookingLocked,
  )

const postBookingLockedAutoRefund = (bid: BookingId, pnr: string) =>
  transport("POST", bid, `/mmb/v1/bookings/${bid}/handover/automated_refund`, null, {
    reservation_number: pnr,
  })

export const loadBookingLockedCredentialsAction = (bid: BookingId) => {
  return {
    type: GET_BOOKING_LOCKED_CREDENTIALS,
    promise: fetchBookingLockedCredentials(bid),
    _track: {},
  }
}

export const handleAutoRefundAction = (pnr: string) => async (
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getState: () => any,
) => {
  const bid = bidSelector(getState())
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/await-thenable
  const ok = await dispatch({
    type: POST_BOOKING_LOCKED_AUTO_REFUND,
    promise: postBookingLockedAutoRefund(bid, pnr),
    _track: {},
  })

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ok) {
    dispatch(loadBookingLockedCredentialsAction(bid))
  }
}

type State = {
  data: BookingLocked
  isLoading: boolean
  hasError: boolean
  isLoadingRefund: boolean
  hasErrorRefund: boolean
}

export type LoadBookingLockedCredentialsAction = {
  type: typeof GET_BOOKING_LOCKED_CREDENTIALS
  res: BookingLocked
}

const initialState = {
  data: {},
  isLoading: false,
  hasError: false,
  isLoadingRefund: false,
  hasErrorRefund: false,
} as const

export default function (
  // @ts-expect-error: Flow to TS migration.
  state: State | null | undefined = initialState,
  action: LoadBookingLockedCredentialsAction,
) {
  switch (action.type) {
    // @ts-expect-error: Flow to TS migration.
    case GET_BOOKING_LOCKED_CREDENTIALS_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      }
    // @ts-expect-error: Flow to TS migration.
    case GET_BOOKING_LOCKED_CREDENTIALS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.res,
      }
    // @ts-expect-error: Flow to TS migration.
    case GET_BOOKING_LOCKED_CREDENTIALS_FAILURE:
      return {
        ...state,
        isLoading: false,
        // @ts-expect-error: Flow to TS migration.
        hasError: Boolean(action.error),
      }
    // @ts-expect-error: Flow to TS migration.
    case POST_BOOKING_LOCKED_AUTO_REFUND_REQUEST:
      return {
        ...state,
        isLoadingRefund: true,
        hasErrorRefund: false,
      }
    // @ts-expect-error: Flow to TS migration.
    case POST_BOOKING_LOCKED_AUTO_REFUND_FAILURE:
      return {
        ...state,
        isLoadingRefund: false,
        // @ts-expect-error: Flow to TS migration.
        hasErrorRefund: Boolean(action.error),
      }
    // @ts-expect-error: Flow to TS migration.
    case POST_BOOKING_LOCKED_AUTO_REFUND_SUCCESS:
      return {
        ...state,
        isLoadingRefund: false,
      }
    default:
      return state
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const bookingLockedErrorSelector = (state: any): boolean => state.bookingLocked.hasError
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const bookingLockedSelector = (state: any): BookingLocked => state.bookingLocked.data

// @ts-expect-error: Flow to TS migration.
export const bookingLockedCredentialsSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  BookingLockedCredentialsWithFlight[]
> = createSelector([bookingDataSelector, bookingLockedSelector], (booking, data: BookingLocked) => {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!data?.credentials) return []
  let segments: BookingLockedCredentialsWithFlight[] = []
  // @ts-expect-error: Flow to TS migration.
  const flights = booking.journey.getFlights().toJS()

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  data.credentials?.forEach((current: BookingLockedCredentials) => {
    // @ts-expect-error: Flow to TS migration.
    const flight = flights.find((f) => f.id === current.segmentCode)
    if (flight) {
      const isDuplicateSegment = segments
        .map(({ segmentCode }) => segmentCode)
        .includes(current.segmentCode)

      const existingPNRSegment = segments.find(({ pnr }) => current.pnr === pnr)
      if (existingPNRSegment) {
        // NOTE: segment data will be the same so can only rely on flights here.
        // But no issue as that is all we need for the card.
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        existingPNRSegment.flights = [...existingPNRSegment?.flights, flight]
      } else {
        // New segment
        segments = [
          ...segments,
          {
            ...current,
            flights: [flight],
            isDuplicateSegment,
          },
        ]
      }
    } else {
      mmbTrack(
        {
          module: BookingLockedModule,
          action: UnexpectedServerResponseAction,
          detail: "no flight found matching segment code",
        },
        { segmentCode: current.segmentCode },
      )
    }
  })
  return segments
})

// @ts-expect-error: Flow to TS migration.
const getAirlineName = (cred: BookingLockedCredentialsWithFlight) => cred.flights[0].airline.name
export const filterDuplicateAirlines = (
  credentials: BookingLockedCredentialsWithFlight[],
): BookingLockedCredentialsWithFlight[] => uniqBy(getAirlineName, credentials)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const shouldShowRyanairGuideSelector: OutputSelector<any, any, boolean> = createSelector(
  [currentBookingJourneySelector],
  // @ts-expect-error: Flow to TS migration.
  (journey) => journey.getFlights().some((flight) => flight.getIn(["airline", "code"]) === "FR"),
)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const bookingLockedRefundErrorSelector = (state: any): boolean =>
  state.bookingLocked.hasErrorRefund
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const bookingLockedRefundLoadingSelector = (state: any): boolean =>
  state.bookingLocked.isLoadingRefund || state.bookingLocked.isLoading
